'use client';
import React, { useEffect, useRef, useState } from 'react';
import MobileScrollAwareHeader from './mobile-scroll-aware-header';
import { MAIN_CAT_HEADER_ID_MOBILE } from '@cat-ecom/pcc-components/src/components/header/constants';

interface MobileScrollAwareHeaderWrapperProps {
  searchSection: React.ReactNode;
  equipmentSection: React.ReactNode;
  children: React.ReactNode;
}

const MobileScrollAwareHeaderWrapper = ({
  searchSection,
  equipmentSection,
  children
}: MobileScrollAwareHeaderWrapperProps) => {
  const [headerHeight, setHeaderHeight] = useState<number | undefined>(
    undefined
  );
  const headerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const measureHeight = () => {
      const headerElement = document.getElementById(MAIN_CAT_HEADER_ID_MOBILE);
      if (headerElement) {
        headerRef.current = headerElement;
        const height = headerElement.offsetHeight;
        setHeaderHeight(height);
      }
    };

    measureHeight();

    // Set up ResizeObserver to watch for height changes
    const resizeObserver = new ResizeObserver(() => {
      measureHeight();
    });

    // Get the initial element to observe
    const initialHeaderElement = document.getElementById(
      MAIN_CAT_HEADER_ID_MOBILE
    );
    if (initialHeaderElement) {
      resizeObserver.observe(initialHeaderElement);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <MobileScrollAwareHeader
      searchSection={searchSection}
      equipmentSection={equipmentSection}
      headerHeight={headerHeight}
    >
      {children}
    </MobileScrollAwareHeader>
  );
};

export default MobileScrollAwareHeaderWrapper;
